import gql from 'graphql-tag'
import { BUSINESS_ENTITY_FRAGMENT } from '@/components/compliances/queries/Compliances'

export const UpdatePrimaryBusinessEntityMutation = gql`
  mutation updatePrimaryBusinessEntity($input: UpdatePrimaryBusinessEntityInput!) {
    updatePrimaryBusinessEntity(input: $input) {
      ...BusinessEntityFragment
    }
  }
  ${BUSINESS_ENTITY_FRAGMENT}
`
